import { tx as translateInterfaceText } from '@/utils/i18n';

import { platformsData } from './platformsData';

export type WebhookStatus = 'active' | 'waiting' | 'error' | 'creation';

export interface WebhookData {
  id: string; // Unique identifier for each webhook
  platform: string; // Slug da plataforma (ex: 'hotmart')
  platformId: number; // ID numérico da plataforma na API
  url: string;
  status: WebhookStatus;
  selectedVideoId: string;
  integrationId?: string | number; // ID retornado pela API após criar o tracking (UUID ou number)
  platformToken?: string; // Token gerado pela plataforma (token_plataform)
}

export interface WebhooksTableProps {
  onTabChange?: () => void;
  savedWebhooks?: WebhookData[];
  onWebhooksSaved?: (webhooks: WebhookData[]) => void;
  activeTab?: string;
  setActiveTab?: (tab: string) => void;
  onBack?: () => void;
}

export interface StatusLabelInfo {
  label: string;
  className: string;
}

export const getPlatformName = (platformId: string) => {
  const platform = platformsData.find(p => p.id === platformId);
  return platform?.name || platformId;
};

export const getPlatformLogo = (platformId: string) => {
  const platform = platformsData.find(p => p.id === platformId);
  return platform?.logo || '';
};

export const getStatusLabel = (status: WebhookStatus): StatusLabelInfo => {
  switch (status) {
    case 'active':
      return { label: translateInterfaceText("Ativo"), className: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100' };
    case 'waiting':
      return { label: translateInterfaceText("Aguardando 1ª venda"), className: 'bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100' };
    case 'creation':
      return { label: translateInterfaceText("Em criação"), className: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100' };
    case 'error':
      return { label: translateInterfaceText("Erro"), className: 'bg-red-50 text-red-700 border-red-200 hover:bg-red-100' };
  }
};
